import React from 'react'
import './eval-question.styles.scss'

const EvalQuestion = ({ question, formData, saveData }) => {
  const value = formData[question.id]

  return (
    <div className='eval-question'>
      <label className='eval-question_prompt'>
        {question.prompt}
        {
          (question.type !== 'info' && !question.required) && 
          <span className='meta'>(Optional)</span>
        }
      </label>

      {/* Short Answer */}
      {question.type === 'short' && (
        <input
          type='text'
          value={value || ''}
          onChange={e => saveData(question.id, e.target.value)}
        />
      )}

      {/* Paragraph */}
      {question.type === 'long' && (
        <textarea
          rows='4'
          value={value || ''}
          onChange={e => saveData(question.id, e.target.value)}
        />
      )}

      {/* Multiple Choice — dropdown or radio buttons */}
      {question.type === 'multiple_choice' && (
        question.displayFormat === 'select'
          ? (
            <select
              value={value || ''}
              onChange={e => saveData(question.id, e.target.value)}>
              <option value=''>Choose...</option>
              {(question.options || []).map(opt => (
                <option key={opt.id} value={opt.id}>{opt.text}</option>
              ))}
            </select>
          )
          : (
            <div className='eval-question_options'>
              {(question.options || []).map(opt => (
                <label key={opt.id} className='eval-question_option'>
                  <input
                    type='radio'
                    name={question.id}
                    value={opt.id}
                    checked={formData[opt.id] === 1}
                    onChange={() => {
                      question.options.forEach(o => {
                        if (o.id !== opt.id) saveData(o.id, null)
                      })
                      saveData(opt.id, 1)
                    }}
                  />
                  <span className='option-value'>{opt.text}</span>
                </label>
              ))}
            </div>
          )
      )}

      {/* Checkbox */}
      {question.type === 'checkbox' && (
        <div className='eval-question_options'>
          {(question.options || []).map(opt => (
            <label key={opt.id} className='eval-question_option'>
              <input
                type='checkbox'
                checked={formData[opt.id] === 1}
                onChange={e => {
                  e.target.checked ? saveData(opt.id, 1) : saveData(opt.id, null)
                }}
              />
              <span className='option-value'>{opt.text}</span>
            </label>
          ))}
        </div>
      )}

      {/* Likert Scale */}
      {question.type === 'likert_scale' && (
        <div className='eval-question_likert'>
          {(question.options || []).map(opt => (
            <label
              key={opt.id}
              className={`eval-question_likert-option${value === opt.value ? ' selected' : ''}`}>
              <input
                type='radio'
                name={question.id}
                value={opt.value}
                checked={value === opt.value}
                onChange={() => saveData(question.id, opt.value)}
              />
              <span className='eval-question_likert-value'>{opt.value}</span>
              <span className='eval-question_likert-label'>{opt.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  )
}

export default EvalQuestion